<script setup lang="ts">
// 根壳：P8 SSO 引入轻量 router 后，App.vue 只承载 <router-view>。
// 身份路由 /login、/callback 与 vault 工作台 / 各自落独立页面（pages/）。
</script>

<template>
  <router-view />
</template>
